<template>
<div id="fullDiv">
    <el-container>
        <el-main>
            <el-row :gutter="20" :style="{ overflow: 'auto' }">
                <el-col :span="12" v-show="ishasData" :key="item.id" v-for="item in balanceArr">
                    <el-card class="box-card" :style="{ backgroundColor: colors.homePageBackgroundColor }" shadow="hover" style="height: 180; margin-bottom: 18px; font-weight: 600; min-width: 290px;">
                        <div slot="header">
                            <span class="sphead" :style="{ color: colors.titleColor }">{{ item.FullName }}</span>
                            <span class="spstate">
                                <el-tag effect="dark" size="medium" :type="item.Connect == '连接成功' ? 'success' : 'danger'">
                                    {{
                                        item.Connect
                                        }}
                                </el-tag>
                            </span>
                        </div>
                        <el-row>
                            <el-col :span="item.isShowMonitor == '1' ? 15 : 24 ">

                                <el-row>
                                    <el-col :span="24" v-if="item.IsVirtual == true ? false : true">
                                        <el-card class="box-card" :style="{ backgroundColor: colors.homePageBackgroundColor }" shadow="never" style="margin-right:10px;">
                                            <div class="grid-con-1">
                                                <div class="user-info-list-odd">
                                                    <div :class="[item.Connect == '连接成功' ? 'titleleftYes' : 'titleleftNo']" :style="{ color: item.Connect === '连接成功' ? colors.textColor : '' }">开始运行时间</div>
                                                    <div :class="[item.Connect == '连接成功' ? 'contentrightYes' : 'contentrightNo']" :style="{ color: item.Connect === '连接成功' ? colors.textColor : '' }">{{ item.starTime }}</div>
                                                </div>
                                                <div class="user-info-list">
                                                    <div :class="[item.Connect == '连接成功' ? 'titleleftYes' : 'titleleftNo']" :style="{ color: item.Connect === '连接成功' ? colors.textColor : '' }">上次停止时间</div>
                                                    <div :class="[item.Connect == '连接成功' ? 'contentrightYes' : 'contentrightNo']" :style="{ color: item.Connect === '连接成功' ? colors.textColor : '' }">{{ item.downTime }}</div>
                                                </div>
                                                <div class="user-info-list-odd">
                                                    <div :class="[item.Connect == '连接成功' ? 'titleleftYes' : 'titleleftNo']" :style="{ color: item.Connect === '连接成功' ? colors.textColor : '' }">当日运行时长</div>
                                                    <div :class="[item.Connect == '连接成功' ? 'contentrightYes' : 'contentrightNo']" :style="{ color: item.Connect === '连接成功' ? colors.textColor : '' }">{{ item.runningTime }}</div>
                                                </div>
                                            </div>
                                        </el-card>
                                    </el-col>
                                </el-row>

                                <el-row>
                                    <el-col :span="24">
                                        <el-card class="box-card" :style="{ backgroundColor: colors.homePageBackgroundColor }" shadow="never" style="margin-right:10px;">
                                            <div class="grid-con-1">
                                                <div class="user-info-list-odd">
                                                    <div :class="[item.Connect == '连接成功' ? 'titleleftYes' : 'titleleftNo']" :style="{ color: item.Connect === '连接成功' ? colors.textColor : '' }">累计(t)</div>
                                                    <div :class="[item.Connect == '连接成功' ? 'contentrightYes' : 'contentrightNo']" :style="{ color: item.Connect === '连接成功' ? colors.textColor : '' }">{{ item.totalOutput }}</div>
                                                </div>
                                                <div class="user-info-list">
                                                    <div :class="[item.Connect == '连接成功' ? 'titleleftYes' : 'titleleftNo']" :style="{ color: item.Connect === '连接成功' ? colors.textColor : '' }">流量(t/h)</div>
                                                    <div :class="[item.Connect == '连接成功' ? 'contentrightYes' : 'contentrightNo']" :style="{ color: item.Connect === '连接成功' ? colors.textColor : '' }">{{ item.insFlow }}</div>
                                                </div>
                                                <div class="user-info-list-odd" v-if="item.IsVirtual == true ? false : true">
                                                    <div :class="[item.Connect == '连接成功' ? 'titleleftYes' : 'titleleftNo']" :style="{ color: item.Connect === '连接成功' ? colors.textColor : '' }">带速(m/s)</div>
                                                    <div :class="[item.Connect == '连接成功' ? 'contentrightYes' : 'contentrightNo']" :style="{ color: item.Connect === '连接成功' ? colors.textColor : '' }">{{ item.beltSpeed }}</div>
                                                </div>
                                            </div>
                                        </el-card>
                                    </el-col>
                                </el-row>
                            </el-col>
                            <el-col :span="8">
                                <video-player v-if="item.isShowMonitor == '1' ? true : false " v-once class="video-player vjs-custom-skin" :playsinline="true" :options="item.monitorEqu|videoOption"></video-player>
                            </el-col>
                            <el-row>
                                <el-col :span="12" v-if="item.IsVirtual == true ? false : true">
                                    <el-card class="box-card" :style="{ backgroundColor: colors.homePageBackgroundColor }" shadow="never" style="margin-right:10px">
                                        <div class="grid-con-1">
                                            <div :class="[index % 2 == 0 ? 'user-info-list-odd' : 'user-info-list']" :key="newItem.name" v-for="(newItem, index) in item.Data">
                                                <div :class="[item.Connect == '连接成功' ? 'titleleftYes' : 'titleleftNo']" :style="{ color: item.Connect === '连接成功' ? colors.textColor : '' }">{{ newItem.name }}(t)</div>
                                                <div :class="[item.Connect == '连接成功' ? 'contentrightYes' : 'contentrightNo']" :style="{ color: item.Connect === '连接成功' ? colors.textColor : '' }">{{ newItem.freWeight }}</div>
                                            </div>
                                        </div>
                                    </el-card>
                                </el-col>
                                <el-col :span="12" v-if="item.IsVirtual == true ? false : true">
                                    <el-card class="box-card" :style="{ backgroundColor: colors.homePageBackgroundColor }" shadow="never" style="margin-bottom: 10px;margin-right:10px;">
                                        <div class="grid-con-1">
                                            <div class="user-info-list-odd">
                                                <div :class="[item.Connect == '连接成功' ? 'titleleftYes' : 'titleleftNo']" :style="{ color: item.Connect === '连接成功' ? colors.textColor : '' }">日产量(t)</div>
                                                <div :class="[item.Connect == '连接成功' ? 'contentrightYes' : 'contentrightNo']" :style="{ color: item.Connect === '连接成功' ? colors.textColor : '' }">{{ item.dayProduction }}</div>
                                            </div>
                                            <div class="user-info-list">
                                                <div :class="[item.Connect == '连接成功' ? 'titleleftYes' : 'titleleftNo']" :style="{ color: item.Connect === '连接成功' ? colors.textColor : '' }">月产量(t)</div>
                                                <div :class="[item.Connect == '连接成功' ? 'contentrightYes' : 'contentrightNo']" :style="{ color: item.Connect === '连接成功' ? colors.textColor : '' }">{{ item.monthProduction }}</div>
                                            </div>
                                            <div class="user-info-list-odd">
                                                <div :class="[item.Connect == '连接成功' ? 'titleleftYes' : 'titleleftNo']" :style="{ color: item.Connect === '连接成功' ? colors.textColor : '' }">年产量(t)</div>
                                                <div :class="[item.Connect == '连接成功' ? 'contentrightYes' : 'contentrightNo']" :style="{ color: item.Connect === '连接成功' ? colors.textColor : '' }">{{ item.yearProduction }}</div>
                                            </div>
                                        </div>
                                    </el-card>
                                </el-col>
                            </el-row>
                        </el-row>
                        <el-button v-if="item.IsVirtual == true ? false : true" class="button-color" :style="getButtonStyle(item)" @mouseover.native="changeHoverColor(item)" @mouseout.native="resetColor(item)" @click="gotolink(item.BalanceId,item.monitorEqu)">查看更多信息</el-button>
                    </el-card>
                </el-col>
                <el-col :span="8" v-if="!ishasData">
                    <el-row>
                        <el-col :span="14">
                            <el-card shadow="hover" style="height: 300px; margin: 10px">
                                <img src="../../assets/img/searchempty.jpg" class="image" style="height: 240px; border-radius: 50%" />

                                <div class="user-info-list">
                                    <span style="margin-left: 35%">查无数据</span>
                                </div>
                            </el-card>
                        </el-col>
                    </el-row>
                </el-col>
            </el-row>
        </el-main>
    </el-container>
</div>
</template>

<script>
import 'videojs-contrib-hls';
import noVideo from '../../assets/img/noVideo.png';
import yesVideo from '../../assets/img/yesVideo.png';

export default {
    filters: {
        videoOption(val) {
            var vPic = val.indexOf('.m3u8') > -1 ? yesVideo : noVideo;
            return {
                live: false,
                preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
                autoplay: true, // 如果为true,浏览器准备好时开始回放
                language: 'zh-CN',
                aspectRatio: '5:4', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
                fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
                sources: [{
                    src: val // url地址
                }],
                poster: vPic, // 封面地址
                notSupportedMessage: '该设备未添加监控或配置错误', // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
                controlBar: {
                    timeDivider: false, // 当前时间和持续时间的分隔符
                    durationDisplay: false, // 显示持续时间
                    remainingTimeDisplay: false, // 是否显示剩余时间功能
                    fullscreenToggle: true // 是否显示全屏按钮
                }
            };
        }
    },
    data() {
        return {
            colors: {
                menuBarBackgroundColor: '#999',
                homePageBackgroundColor: '#999',
                titleColor: '#999',
                textColor: '#999',
                buttonColor: '#999',
                buttonColor2: '#999',
            },
            buttonStyle: {
                color: '#ffffff',
                fontSize: '20px',
                fontWeight: 'bold',
                fontFamily: '微软雅黑',
                backgroundColor: 'rgb(50, 65, 87)',
                borderColor: '#ffffff',
                borderWidth: '3px',
                marginTop: '-20px'
            },
            param: {
                username: '',
                password: ''
            },
            deviceName: '',
            isshow: false,
            screenheight: '',
            picsrc: '../../assets/img/searchempty.jpg',
            name: localStorage.getItem('ms_username'),
            structArr: [],
            balanceArr: [],
            columnNum: 24,
            ishasData: true,
            isShowVideo: true,
            timer: 0,
            activeName: 'first',
            videoFlag: 0,
        }
    },
    created() {
        this.getstructArr();
        this.getSystemInfo();
    },
    mounted: function () {
        if (this.timer) {
            clearInterval(this.timer);
        } else {
            this.timer = setInterval(() => {
                this.getstructArr();
            }, 1000 * 2)
        }
    },
    destroyed() {
        clearInterval(this.timer);
    },
    methods: {
        gotolink: function (param1, param2) {
            //指定跳转地址
            this.$router.push({
                path: "/MoreDeviceInfo",
                query: {
                    id: param1,
                    videoUrl: param2
                },
            });
        },
        handleClick(tab, event) {
            console.log(tab, event);
        },
        getData() {
            this.ishasData = true;
        },
        getstructArr() {
            let username = localStorage.getItem('ms_username');
            let userInfo = JSON.parse(localStorage.getItem('ms_userInfo'));
            this.$zybhttp
                .post('Business/GetIndexData', {
                    Field1: userInfo.userType,
                    Field2: userInfo.realName,
                })
                .then((res) => {
                    if (res.data.status == 0) {
                        var data = res.data.data.list;
                        for (let i = 0; i < data.length; i++) {
                            data[i].insFlow = parseFloat(data[i].insFlow).toFixed(2);
                            data[i].beltSpeed = parseFloat(data[i].beltSpeed).toFixed(2);
                            var videoUrl = data[i].monitorEqu;
                            videoUrl = videoUrl == '' ? '' : `${this.GlobalConfig.baseUrl}VideoStream/${data[i].monitorEqu}/video.m3u8`;
                            data[i].monitorEqu = videoUrl;
                            this.yData = [];
                            for (var key in data[i].hourData) {
                                this.yData.push(data[i].hourData[key].weight);
                            }
                        }
                        if (this.balanceArr.length == data.length) {
                            this.balanceArr = data;
                        } else {
                            this.balanceArr = JSON.parse(JSON.stringify(data));
                        }
                        var dataLength = this.balanceArr.length;
                        if (dataLength > 0) {
                            this.ishasData = true;
                        } else {
                            this.ishasData = false;
                        }
                    } else {
                        this.$notify.error(res.message);
                    }
                })
                .catch((err) => this.$notify.error('网络异常！获取列表失败！'));
        },
        getSystemInfo() {
            this.$zybhttp
                .get('Business/GetSystemInfo', {})
                .then((res) => {
                    if (res.data.status == 0) {
                        var d = res.data;
                        this.version = d.msg;
                        this.colors.menuBarBackgroundColor = d.data.list[0].menuBarBackgroundColor;
                        this.colors.homePageBackgroundColor = d.data.list[0].homePageBackgroundColor;
                        this.colors.titleColor = d.data.list[0].titleColor;
                        this.colors.textColor = d.data.list[0].textColor;
                        this.colors.buttonColor = d.data.list[0].buttonColor;
                        this.colors.buttonColor2 = d.data.list[0].buttonColor2;
                        this.buttonStyle.color = this.colors.textColor; // 修改文字颜色为红色
                        this.buttonStyle.backgroundColor = this.colors.buttonColor; // 修改背景色为蓝色
                        this.buttonStyle.borderColor = this.colors.textColor; // 修改边框颜色为绿色
                    } else {
                        this.$notify.error(res.message);
                    }
                })
                .catch((err) => this.$notify.error('网络异常！获取列表失败！'));
        },
        getButtonStyle(item) {
            return {
                color: this.buttonStyle.color,
                fontSize: '20px',
                fontWeight: 'bold',
                fontFamily: '微软雅黑',
                backgroundColor: item.isHovered ? this.colors.buttonColor2 : this.colors.buttonColor,
                borderColor: this.buttonStyle.borderColor,
                borderWidth: '3px',
                marginTop: '-20px',
            };
        },
        changeHoverColor(item) {
            this.$set(item, 'isHovered', true);
            // this.buttonStyle.backgroundColor = this.colors.buttonColor2;
        },
        resetColor(item) {
            this.$set(item, 'isHovered', false);
            // this.buttonStyle.backgroundColor = this.colors.buttonColor;
        },
    }
};
</script>

<style scoped>
.button-color {
    /* 按钮文字颜色 */
    color: #ffffff;
    font-size: 20px;
    font-weight: bold;
    font-family: 微软雅黑;
    /* 按钮背景色 */
    background-color: rgb(50, 65, 87);
    /* 按钮边框颜色 */
    border-color: #ffffff;
    border-width: 3px;
    margin-top: -20px;
}

.button-color:hover {
    /* 按钮获取焦点颜色 */
    background-color: rgb(87, 106, 134);
}

.box-card {
    /* 背景色 */
    background-color: rgb(50, 65, 87);
}

.login-btn {
    text-align: center;
}

.login-btn button {
    width: 100%;
    height: 36px;
    margin-bottom: 10px;
}

.el-row {
    margin-bottom: 20px;
}

.handle-select {
    width: 200px;
}

.user-info-list {
    font-size: 26px;
    color: #999;
    line-height: 30px;
    display: -webkit-flex;
}

.user-info-list-odd {
    font-size: 26px;
    color: #999;
    line-height: 30px;
    display: -webkit-flex;
}

.titleleftNo {
    width: 40%;
    padding-left: 0.5rem;
    color: crimson;
    font-weight: bold;
    font-family: 微软雅黑;
}

.titleleftYes {
    width: 40%;
    padding-left: 0.5rem;
    /* 运行状态名称颜色 */
    color: #ffffff;
    font-weight: bold;
    font-family: 微软雅黑;
}

.contentleft {
    width: 60%;
    color: crimson;
    font-family: 微软雅黑;
}

.el-card__header {
    background-color: cornsilk;
}

.sphead {
    font-size: 27px;
    /* 标题颜色 */
    color: rgb(232, 244, 255);
    font-family: cursive;
}

.nologin {
    float: right;
    font-size: 14px;
    color: red;
    margin-right: 10px;
    margin-top: 5px;
}

.spstate {
    float: right;
}

.contentrightNo {
    width: 60%;
    color: crimson;
    font-weight: bold;
    font-family: 微软雅黑;
}

.contentrightYes {
    width: 60%;
    font-weight: bold;
    /* 动态信息颜色 */
    color: #ffffff;
    font-family: 微软雅黑;
}
</style><style>
.el-card__body {
    padding: 10px 20px;
    font-weight: 500;
}

element.style {
    background: #e0dcda;
}

.el-card__header {
    padding: 10px 20px;
}

.tagClass .el-tag {
    font-size: 24px;
}

.tagClass .el-tag--small {
    height: 32px;
    padding: 0 10px;
    line-height: 32px;
}
</style>
